var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 291 c-11 -21 -14 -263 -4 -274 4 -3 19 0 34 8 23 12 30 12 48 -1 19 -13 25 -13 50 0 26 13 31 13 51 0 27 -20 30 -13 33 91 3 75 4 79 28 85 19 4 26 13 28 37 2 18 -2 41 -8 53 -10 18 -20 20 -130 20 -108 0 -120 -2 -130 -19z m192 -126 c-3 -113 -5 -124 -20 -116 -11 6 -26 5 -44 -5 -25 -13 -31 -13 -53 2 -20 13 -29 14 -38 5 -6 -6 -15 -11 -19 -11 -10 0 -11 234 -1 243 3 4 45 7 92 7 l86 0 -3 -125z m53 84 c0 -24 -5 -34 -15 -34 -16 0 -25 37 -16 62 10 26 31 8 31 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 223 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 170 c0 -5 20 -10 45 -10 25 0 45 5 45 10 0 6 -20 10 -45 10 -25 0 -45 -4 -45 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 120 c-4 -6 12 -10 40 -10 28 0 44 4 40 10 -3 6 -21 10 -40 10 -19 0 -37 -4 -40 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.01bf68d68846b8748c142ceb2d729a80.svg";
export { ForwardRef as ReactComponent };